import { useExperiments } from '@wix/fe-essentials-standalone';
import { useTranslation } from '@wix/wix-i18n-config';

import { EXPERIMENTS } from '../../constants';

export type ResolveBabelSeo = <T extends string | undefined>(
  key: string,
  fallback: T,
  params?: Record<string, string>,
) => T | string;

export const useBabelSeo = (): ResolveBabelSeo => {
  const { experiments } = useExperiments({ readOnly: true });
  const { t } = useTranslation();
  const enabled = experiments.enabled(EXPERIMENTS.SPECS.SEO_FROM_BABEL);

  return (key, fallback, params) => {
    if (!enabled) {
      return fallback;
    }
    const resolved = t(key, params);
    if (!resolved || resolved === key) {
      return fallback;
    }
    return resolved;
  };
};
